import { render, staticRenderFns } from "./TextSignatureCanvas.vue?vue&type=template&id=6025bcf6&scoped=true"
import script from "./TextSignatureCanvas.vue?vue&type=script&lang=js"
export * from "./TextSignatureCanvas.vue?vue&type=script&lang=js"
import style0 from "./TextSignatureCanvas.vue?vue&type=style&index=0&id=6025bcf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025bcf6",
  null
  
)

export default component.exports